import { Component, ComponentOptions } from "./component";
import { TemplateComponent } from "./templateComponent";

const template = `
    <div id="#= data.id #" class="site-container">
        #= data.components #
    </div>
`;

export interface SiteContainerOptions extends ComponentOptions {
    components?: Component[];
}

export class SiteContainer extends TemplateComponent {

    options: SiteContainerOptions;
    content: {
        components: Component[];
    };

    constructor(options: SiteContainerOptions) {
        super(template, options);

        this.content = {
            components: options.components || []
        };
    }

}
